import { render } from "./ParamTaxTypePageList.vue?vue&type=template&id=da9d467e&scoped=true&ts=true"
import script from "./ParamTaxTypePageList.vue?vue&type=script&lang=ts"
export * from "./ParamTaxTypePageList.vue?vue&type=script&lang=ts"

import "./ParamTaxTypePageList.vue?vue&type=style&index=0&id=da9d467e&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da9d467e"]])

export default __exports__